//ده الكود الاصلي  بس معموله ك
// import React, { useEffect, useState } from 'react';
// import { json, Link, useNavigate } from 'react-router-dom';
// import "./AdditionalBaggageCard.css"
// import { getDomainName } from '../Api/GetBaseUrl';
// import Counter from '../common/Counter';
// import { useSelector } from 'react-redux';


// const AdditionalBaggageCard = ({ services }) => {
//   console.log('services in meals card', services)

//   const flight = JSON.parse(localStorage.getItem('flight') || '{}');
//   const timeSTD = flight.std; //15:01:00
//   const time = new Date().toLocaleTimeString('en-GB', { hour12: false });


//   const { translations, lang } = useSelector((state) => state.languageReducer)
//   const navigate = useNavigate();
//   const domainName = getDomainName();

//   const [total, setTotal] = useState(0);
//   const [error, setError] = useState("");
//   const [tempServices, setTempServices] = useState([]);
//   const handleCounterChange = (name, value) => {
//     // console.log('name', name)
//     // console.log('value', value)
//     const temp = [...tempServices];
//     console.log('temp', tempServices)
//     tempServices.map((tempService, idx) => {
//       if (name == tempService.id) {
//         temp[idx] = { ...tempService, count: value }
//       }
//     })
//     setTempServices(temp);
//   }
//   const addServeses = () => {
//     const servs = tempServices.filter((service) => service.count > 0);
//     let local = localStorage.getItem('serveces');
//     if (local && local !== "[]") {
//       local = JSON.parse(local);
//       const allServeces = [];
//       local.map((serv) => {
//         const help = tempServices.filter((h) => h.id === serv.id)
//         if (help.length > 0) {
//           if (help[0].count > 0) {
//             allServeces.push(help[0])
//           }

//         } else {
//           allServeces.push(serv)
//         }

//       })
//       servs.map((serv) => {
//         const help = local.filter((h) => h.id === serv.id)
//         if (help.length > 0) {
//         } else {
//           allServeces.push(serv)
//         }

//       })

//       localStorage.setItem('serveces', JSON.stringify(allServeces))
//     } else {
//       localStorage.setItem('serveces', JSON.stringify(servs))
//     }

//     navigate("/");





//   }
//   useEffect(() => {
//     let locals = localStorage.getItem('serveces');
//     const servs = []
//     if (locals) {
//       locals = JSON.parse(locals);
//       services.map((service) => {
//         const help = locals.filter((local) => local.id === service.id)
//         if (help.length > 0) {
//           servs.push({ ...help[0], price: service.price })
//         } else {
//           servs.push({ id: service.id, title: service.title, description: service.description, image: service.image, price: service.price, count: 0, category_id: service.category.id ,min_hours:service.category.min_hours})
//         }

//       })

//     } else {
//       services.map((service) => {
//         servs.push({ id: service.id, title: service.title, description: service.description, image: service.image, price: service.price, count: 0, category_id: service.category.id ,min_hours:service.category.min_hours})
//       })
//     }
//     setTempServices(servs);
//   }, [services])

//   console.log('tempServices', tempServices)
//   useEffect(() => {
//     setError("")
//     let t = 0;
//     tempServices.map((seleced) => {
//       t += seleced.price * seleced.count;
//     })
//     setTotal(t)
//   }, [tempServices])
//   return (
//     <div className='w-100 bg-white p-3 mt-4' style={{ borderRadius: '30px' }}>
//       <div className=''>

//         <div className='continar text-center mt-2' >
//           {services[0].category.title === "MEALS ON BOARD" || services[0].category.id === 11 ? (
//             <div className='row continar  ' style={{ width: '95%', margin: 'auto' }} >
//               {tempServices.map((meal, idx) => (

//                 <div className=' col-lg-6   mb-5 ' >
//                   {meal.image && (
//                     <img alt='mealPhoto' className='imgs' style={{ height: '300px', width: '100%', objectFit: "cover" }} src={`${domainName}/${meal.image}`} />
//                   )}
//                   <div className=' d-flex justify-content-end'>
//                     <div className='position-relative  message-container'>
//                       <i className="fa-regular fa-circle-question  message-container" style={{ margin: "5px" }}>
//                       </i>
//                       <div className='message-show-details'>
//                         {meal.description}
//                       </div>
//                     </div>
//                   </div>
//                   <div className='d-flex flex-column flex-sm-row mt-3   justify-content-between align-items-center ' style={{ width: '90%', margin: 'auto' }}>

//                     <div className='d-flex gap-1 align-items-center mb-4 me-3'>
//                       {/* <input type='radio' style={{width:'20px',height:'20px'}}/>  */}
//                       <p className='m-0 fw-bold' style={{ fontSize: '18px' }}>{meal.title}</p>
//                     </div>
//                     <div className='d-flex gap-3 justify-content-between align-items-center mb-4'>
//                       <div className='' style={{ color: "gray", fontSize: '18px' }}><span style={{ color: '#273771' }} className='me-2'>{translations.Price}</span>  {meal.price} {translations.EGP} </div>
//                       <Counter
//                         name={meal.id}
//                         defaultValue={meal.count}
//                         onCounterChange={handleCounterChange}
//                       />
//                     </div>
//                   </div>

//                   <span > <span className='EGP'></span></span>
//                 </div>
//               ))}

//             </div>
//           ) : (
//             <div className='d-flex flex-column gap-4 continar '  >

//               <div className='d-flex flex-column gap-5 mt-4' >
//                 {tempServices.map((meal, idx) => (
//                   <div className='row align-items-center '>
//                     <div className='col-md-8 '>
//                       <div className='d-flex flex-column gap-2 align-items-center align-items-md-start' style={{ width: '90%' }}>
//                         <h4 className='fw-bold' style={{ color: '#292929' }}>{meal.title}</h4>
//                         <p className=' m-0 ' style={{ color: 'gray', textAlign: 'start' }}>{meal.description}</p>
//                         <p className=' m-0' style={{ color: '#292929' }}><span style={{ color: '#273771' }} className='me-2 '>{translations.Price}</span> {meal.price} {translations.EGP}</p>
//                       </div>
//                     </div>
//                     <div className='col-md-3'>
//                       <div className='d-flex gap-5 my-3 align-items-center justify-content-center'>
//                         <Counter
//                           name={meal.id}
//                           defaultValue={meal.count}
//                           onCounterChange={handleCounterChange}
//                         />
//                       </div>
//                     </div>
//                     <div className='col-md-1'>
//                       <div className='d-flex flex-column gap-3 align-items-center align-items-lg-end'>
//                         <div style={{ color: "#292929", fontSize: '18px' }}><span className='me-1' style={{ color: '#273771' }}>{translations.EGP}</span> {meal.price * meal.count}  </div>
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           )}
//           <br />
//           <hr />
//           <div className='text-end py-2'>
//             <div className='d-flex flex-column gap-3 flex-sm-row justify-content-between align-items-center px-3'>
//               <div>
//                 <span style={{ fontSize: "20px" }} className=' me-4  '>{translations.Total}</span>
//                 <span style={{ fontSize: "16px" }} className=''>{translations.EGP} <span style={{ fontSize: "20px", fontWeight: 'bold', color: '#292929' }} className='ms-1'>{total}</span></span>
//                 <div className='text-end'>
//                   <span style={{ fontSize: "16px", color: 'red' }} className=''>{error}</span>
//                 </div>
//               </div>
//               <button onClick={addServeses} style={{ width: '150px', margin: '0' }} className='Login-button'>
//                 {translations.Confirm}
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   )
// }

// export default AdditionalBaggageCard
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import "./AdditionalBaggageCard.css"
import { getDomainName } from '../Api/GetBaseUrl';
import Counter from '../common/Counter';
import { useSelector } from 'react-redux';
import { getServiceAvailability } from '../../utils/serviceAvailability';

const AdditionalBaggageCard = ({ services }) => {
  const flight = JSON.parse(localStorage.getItem('flight') || '{}');
  const departureDate = flight.departure_date;
  const timeSTD = flight.std;

  const { translations } = useSelector((state) => state.languageReducer);
  const navigate = useNavigate();
  const domainName = getDomainName();

  const [total, setTotal] = useState(0);
  const [error, setError] = useState("");
  const [tempServices, setTempServices] = useState([]);

  const handleCounterChange = (name, value) => {
    const temp = [...tempServices];
    tempServices.forEach((tempService, idx) => {
      if (name === tempService.id) {
        temp[idx] = { ...tempService, count: value };
      }
    });
    setTempServices(temp);
  };

  const addServeses = () => {
    const servs = tempServices.filter((service) => service.count > 0);
    let local = localStorage.getItem('serveces');

    if (local && local !== "[]") {
      local = JSON.parse(local);
      const allServeces = [];

      local.forEach((serv) => {
        const help = tempServices.filter((h) => h.id === serv.id);
        if (help.length > 0) {
          if (help[0].count > 0) allServeces.push(help[0]);
        } else {
          allServeces.push(serv);
        }
      });

      servs.forEach((serv) => {
        const help = local.filter((h) => h.id === serv.id);
        if (help.length === 0) allServeces.push(serv);
      });

      localStorage.setItem('serveces', JSON.stringify(allServeces));
    } else {
      localStorage.setItem('serveces', JSON.stringify(servs));
    }

    navigate("/");
  };

  useEffect(() => {
    let locals = localStorage.getItem('serveces');
    const servs = [];

    const buildService = (service, savedData = null) => {
      const hoursToClose = service.min_hours > 0
        ? service.min_hours
        : service.category?.min_hours ?? 0;

      return {
        id: service.id,
        title: service.title,
        description: service.description,
        image: service.image,
        price: service.price,
        count: savedData ? savedData.count : 0,
        category_id: service.category.id,
        min_hours: service.min_hours,
        category: service.category,
        isAvailable: getServiceAvailability({
          departureDate,
          std: timeSTD,
          minHours: hoursToClose,
          now: new Date(),
        }),
      };
    };

    if (locals) {
      locals = JSON.parse(locals);
      services.forEach((service) => {
        const saved = locals.find((local) => local.id === service.id);
        servs.push(buildService(service, saved || null));
      });
    } else {
      services.forEach((service) => {
        servs.push(buildService(service));
      });
    }

    setTempServices(servs);
  }, [departureDate, services, timeSTD]);

  useEffect(() => {
    setError("");
    let t = 0;
    tempServices.forEach((selected) => {
      t += selected.price * selected.count;
    });
    setTotal(t);
  }, [tempServices]);

  return (
    <div className='w-100 bg-white p-3 mt-4' style={{ borderRadius: '30px' }}>
      <div className='continar text-center mt-2'>

        {services[0].category.title === "MEALS ON BOARD" || services[0].category.id === 11 ? (
          <div className='row continar' style={{ width: '95%', margin: 'auto' }}>
            {tempServices.map((meal) => (
              <div className='col-lg-6 mb-5' key={meal.id}>
                {meal.image && (
                  <img
                    alt='mealPhoto'
                    className='imgs'
                    style={{
                      height: '300px',
                      width: '100%',
                      objectFit: "cover",
                      filter: meal.isAvailable ? 'none' : 'grayscale(100%)', // ✅
                      opacity: meal.isAvailable ? 1 : 0.5,                   // ✅
                    }}
                    src={`${domainName}/${meal.image}`}
                  />
                )}

                <div className='d-flex justify-content-end'>
                  <div className='position-relative message-container'>
                    <i className="fa-regular fa-circle-question" style={{ margin: "5px" }}></i>
                    <div className='message-show-details'>{meal.description}</div>
                  </div>
                </div>

                {/* ✅ رسالة إن الوجبة اتقفلت */}
                {!meal.isAvailable && (
                  <div className='text-danger fw-bold mt-1' style={{ fontSize: '13px' }}>
                    {translations.MealUnavailable || "This meal is no longer available for booking"}
                  </div>
                )}

                <div className='d-flex flex-column flex-sm-row mt-3 justify-content-between align-items-center' style={{ width: '90%', margin: 'auto' }}>
                  <div className='d-flex gap-1 align-items-center mb-4 me-3'>
                    <p className='m-0 fw-bold' style={{ fontSize: '18px' }}>{meal.title}</p>
                  </div>

                  <div className='d-flex gap-3 justify-content-between align-items-center mb-4'>
                    <div style={{ color: "gray", fontSize: '18px' }}>
                      <span style={{ color: '#273771' }} className='me-2'>{translations.Price}</span>
                      {meal.price} {translations.EGP}
                    </div>

                    <Counter
                      name={meal.id}
                      defaultValue={meal.count}
                      onCounterChange={handleCounterChange}
                      disabled={!meal.isAvailable} // ✅
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className='d-flex flex-column gap-4 continar'>
            <div className='d-flex flex-column gap-5 mt-4'>
              {tempServices.map((meal) => (
                <div className='row align-items-center' key={meal.id}>
                  <div className='col-md-8'>
                    <div className='d-flex flex-column gap-2 align-items-center align-items-md-start' style={{ width: '90%' }}>
                      <h4 className='fw-bold' style={{ color: '#292929' }}>{meal.title}</h4>
                      <p className='m-0' style={{ color: 'gray', textAlign: 'start' }}>{meal.description}</p>
                      <p className='m-0' style={{ color: '#292929' }}>
                        <span style={{ color: '#273771' }} className='me-2'>{translations.Price}</span>
                        {meal.price} {translations.EGP}
                      </p>
                      {/* ✅ رسالة إن الخدمة اتقفلت */}
                      {!meal.isAvailable && (
                        <span className='text-danger' style={{ fontSize: '13px' }}>
                          {translations.MealUnavailable || "No longer available for booking"}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className='col-md-3'>
                    <div className='d-flex gap-5 my-3 align-items-center justify-content-center'>
                      <Counter
                        name={meal.id}
                        defaultValue={meal.count}
                        onCounterChange={handleCounterChange}
                        disabled={!meal.isAvailable} // ✅
                      />
                    </div>
                  </div>

                  <div className='col-md-1'>
                    <div className='d-flex flex-column gap-3 align-items-center align-items-lg-end'>
                      <div style={{ color: "#292929", fontSize: '18px' }}>
                        <span className='me-1' style={{ color: '#273771' }}>{translations.EGP}</span>
                        {meal.price * meal.count}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        <br />
        <hr />

        <div className='text-end py-2'>
          <div className='d-flex flex-column gap-3 flex-sm-row justify-content-between align-items-center px-3'>
            <div>
              <span style={{ fontSize: "20px" }} className='me-4'>{translations.Total}</span>
              <span style={{ fontSize: "16px" }}>
                {translations.EGP}
                <span style={{ fontSize: "20px", fontWeight: 'bold', color: '#292929' }} className='ms-1'>
                  {total}
                </span>
              </span>
              <div className='text-end'>
                <span style={{ fontSize: "16px", color: 'red' }}>{error}</span>
              </div>
            </div>

            <button
              onClick={addServeses}
              style={{ width: '150px', margin: '0' }}
              className='Login-button'
            >
              {translations.Confirm}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdditionalBaggageCard;